<div mat-dialog-title align="center">
  <h1>{{ 'settings.companies.cancel-event' | translate }}</h1>
  <mat-divider class="divider"></mat-divider>
</div>
<mat-dialog-content class="content" align="center" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="45px">
  <p>{{ 'settings.companies.sure-cancel-event' | translate }}?</p>
  <div fxLayout="column" fxLayoutAlign="start start">
    <p>
      <span>{{ data.eventName }}</span>
    </p>
  </div>
</mat-dialog-content>
<mat-divider class="divider"></mat-divider>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close] [disabled]="waitingResponse">
    {{ 'settings.companies.button-cancel' | translate }}
  </button>
  <button mat-button (click)="deleteEvent()" [disabled]="waitingResponse">
    {{ 'settings.companies.button-confirm' | translate }}
  </button>
</mat-dialog-actions>
